module.exports = __webpack_public_path__ + "img/btn_txt_gaikan.5f9c50c3.png";